import React from 'react';
import MobileDetect from 'mobile-detect';
import styles from '../styles/howToDelete.module.scss';

function HowToDelete() {

    const deviceDetect = () => {
        let type = new MobileDetect(window.navigator.userAgent)
        switch (type.os()) {
            case  'AndroidOS':
                return window.location.href = "https://play.google.com/store/apps/details?id=com.letsup.hamyap&hl=tr&gl=US";
            case 'iOS':
                return window.location.href = "https://apps.apple.com/us/app/ham-yap/id6447787659"
            default:
                return ''
        }
    }

    return (
        <div>
            <div className={styles.header}>
                <div className={styles.header__content}>
                    <div>
                        <span className={styles.logo}>Ham Yap</span>
                    </div>
                </div>
            </div>

            <div className={styles.deleteInfo}>
                <p>You can delete your account by following these steps:</p>
                <p>1. Click on your profile photo</p>
                <p>2. Press the Edit button</p>
                <p>3. Press Delete My Account</p>
                <p>4. Are you sure? </p>
                <p>5. Yes </p>
            </div>
        </div>
      
    )
}

export default HowToDelete;